import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import './v2/styles/tokens-v2.css'
import './v2/styles/shell.css'
import './v2/styles/zones.css'
import './v2/styles/workspace.css'
import './v2/styles/hud.css'
import './v2/styles/flowmap.css'
import './v2/styles/legacy-skin.css'
import './v2/styles/ops-skin.css'
import './v2/styles/effects.css'
import App from './App'
import { ModelProvider } from '@/lib/model'
import { applyDensity, getInitialDensity } from '@/lib/density'
import { bootstrapV2 } from '@/v2/motion/tiers'

// Apply density + the V2 chrome (dark pin, motion-tier class) before
// first paint so neither flashes. V2 is dark-only: ThemeProvider is no
// longer mounted (V1's tovieos-theme key stays untouched, V1-owned).
applyDensity(getInitialDensity())
bootstrapV2()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ModelProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ModelProvider>
  </StrictMode>,
)
